// import { TranslateService } from "ng2-translate";
// import {LotteryGame} from "./LotteryGame";

// /**
//  * Created by Owner on 2016/8/4.
//  */

// export const mbdbFace = (translate: TranslateService): LotteryGame[] => [
//     {
//         isdefault: true,
//         title: translate.instant('DANH_DE'),
//         status: 0,
//         label: [
//             {
//                 gtitle: translate.instant('MIEN_BAC'),
//                 label: [
//                     {
//                         name: translate.instant('DE_DAU_DAC_BIET'),
//                         methodid: 1000,
//                         selectType: "zxfs",
//                         selectArea: {
//                             mname: "dedacbiet",
//                             layout: [
//                                 {
//                                     title: translate.instant('DOZENS'),
//                                     no: "0|1|2|3|4|5|6|7|8|9"
//                                 },
//                                 {
//                                     title: translate.instant('UNIT'),
//                                     no: "0|1|2|3|4|5|6|7|8|9"
//                                 }
//                             ],
//                             noBigIndex: 5,
//                             layoutfastslect: [
//                                 {
//                                     start: '00',
//                                     end: '99'
//                                 }
//                             ]
//                         },
//                         show_str: "X,X,X,X,X",
//                         methoddesc: translate.instant('MMC.SPECIAL_NUMBER_DESC'),
//                         methodhelp: translate.instant('MMC.SPECIAL_NUMBER_HELP'),
//                         guideTxt: translate.instant('GUIDE_TXT'),
//                         methodexample: translate.instant('MMC.SPECIAL_NUMBER_EXAMPLE'),
//                         exampleInfo: "",
//                         modes: [{
//                             modeid: 1,
//                             name: translate.instant('VND'),
//                             rate: 1
//                         }]
//                     },
//                     {
//                         name: translate.instant('TAI_XIU'),
//                         methodid: 200,
//                         selectType: "deTopBot",
//                         selectArea: {
//                             mname: "detx",
//                             LayoutTopBot: [
//                                 {
//                                     title: translate.instant('TAI'),
//                                     no: [
//                                         {
//                                             title: translate.instant('MMC.TAI_PRIZE_8'),
//                                             codePlay: "TAI8",
//                                             methodid: 200,
//                                             rate: 1.95
//                                         },
//                                         {
//                                             title: translate.instant('MMC.TAI_PRIZE_DB'),
//                                             codePlay: "TAIDB",
//                                             methodid: 201,
//                                             rate: 1.95
//                                         },
//                                         {
//                                             title: translate.instant('MMC.TAI_PRIZE_8_OR_DB'),
//                                             codePlay: "TAI8DB",
//                                             methodid: 204,
//                                             rate: 1.3
//                                         },
//                                         {
//                                             title: translate.instant('MMC.TAI_PRIZE_8_AND_DB'),
//                                             codePlay: "TAI8VDB",
//                                             methodid: 205,
//                                             rate: 3.7
//                                         },
//                                         {
//                                             title: translate.instant('MMC.TAI_AND_EVEN_PRIZE_8'),
//                                             codePlay: "TAICHAN8",
//                                             methodid: 206,
//                                             rate: 3.63
//                                         },
//                                         {
//                                             title: translate.instant('MMC.TAI_AND_ODD_PRIZE_8'),
//                                             codePlay: "TAILE8",
//                                             methodid: 207,
//                                             rate: 3.63
//                                         },
//                                         {
//                                             title: translate.instant('MMC.TAI_AND_EVEN_PRIZE_DB'),
//                                             codePlay: "TAICHANDB",
//                                             methodid: 208,
//                                             rate: 3.63
//                                         },
//                                         {
//                                             title: translate.instant('MMC.TAI_AND_ODD_PRIZE_DB'),
//                                             codePlay: "TAILEDB",
//                                             methodid: 209,
//                                             rate: 3.63
//                                         },
//                                     ]
//                                 },
//                                 {
//                                     title: translate.instant('XIU'),
//                                     no: [
//                                         {
//                                             title: translate.instant('MMC.XIU_PRIZE_DB'),
//                                             codePlay: "XIUDB",
//                                             methodid: 202,
//                                             rate: 1.95
//                                         },
//                                         {
//                                             title: translate.instant('MMC.XIU_PRIZE_8'),
//                                             codePlay: "XIU8",
//                                             methodid: 203,
//                                             rate: 1.95
//                                         },
//                                         {
//                                             title: translate.instant('MMC.XIU_PRIZE_8_OR_DB'),
//                                             codePlay: "XIU8DB",
//                                             methodid: 210,
//                                             rate: 1.3
//                                         },
//                                         {
//                                             title: translate.instant('MMC.XIU_PRIZE_8_AND_DB'),
//                                             codePlay: "XIU8VDB",
//                                             methodid: 211,
//                                             rate: 3.7
//                                         },
//                                         {
//                                             title: translate.instant('MMC.XIU_AND_EVEN_PRIZE_8'),
//                                             codePlay: "XIUCHAN8",
//                                             methodid: 212,
//                                             rate: 3.63
//                                         },
//                                         {
//                                             title: translate.instant('MMC.XIU_AND_ODD_PRIZE_8'),
//                                             codePlay: "XIULE8",
//                                             methodid: 213,
//                                             rate: 3.63
//                                         },
//                                         {
//                                             title: translate.instant('MMC.XIU_AND_EVEN_PRIZE_DB'),
//                                             codePlay: "XIUCHANDB",
//                                             methodid: 214,
//                                             rate: 3.63
//                                         },
//                                         {
//                                             title: translate.instant('MMC.XIU_AND_ODD_PRIZE_DB'),
//                                             codePlay: "XIULEDB",
//                                             methodid: 215,
//                                             rate: 3.63
//                                         },
//                                     ]
//                                 }
//                             ],
//                             noBigIndex: 5,
//                             layoutfastslect: [
//                                 {
//                                     start: '00',
//                                     end: '99'
//                                 }
//                             ]
//                         },
//                         show_str: "X,X,X,X,X",
//                         methoddesc: translate.instant('MMC.TAI_DESC'),
//                         methodhelp: translate.instant('MMC.TAI_DB_DESC'),
//                         guideTxt: translate.instant('GUIDE_TXT'),
//                         methodexample: translate.instant('MMC.EXAMPLE'),
//                         exampleInfo: "",
//                         modes: [{
//                             modeid: 1,
//                             name: translate.instant('VND'),
//                             rate: 1
//                         }]
//                     },
//                     {
//                         name: translate.instant('CHAN_LE'),
//                         methodid: 216,
//                         selectType: "deTopBot",
//                         selectArea: {
//                             mname: "de-cl",
//                             LayoutTopBot: [
//                                 {
//                                     title: translate.instant('CHAN'),
//                                     no: [
//                                         {
//                                             title: translate.instant('MMC.EVEN_PRIZE_8'),
//                                             codePlay: "CHAN8",
//                                             methodid: 216,
//                                             rate: 1.95
//                                         },
//                                         {
//                                             title: translate.instant('MMC.EVEN_PRIZE_DB'),
//                                             codePlay: "CHANDB",
//                                             methodid: 218,
//                                             rate: 1.95
//                                         },
//                                         {
//                                             title: translate.instant('MMC.EVEN_PRIZE_8_OR_DB'),
//                                             codePlay: "CHAN8ORDB",
//                                             methodid: 220,
//                                             rate: 1.3
//                                         },
//                                         {
//                                             title: translate.instant('MMC.EVEN_PRIZE_8_AND_DB'),
//                                             codePlay: "CHAN8VDB",
//                                             methodid: 223,
//                                             rate: 3.7
//                                         },
//                                     ]
//                                 },
//                                 {
//                                     title: translate.instant('LE'),
//                                     no: [
//                                         {
//                                             title: translate.instant('MMC.ODD_PRIZE_8'),
//                                             codePlay: "LE8",
//                                             methodid: 217,
//                                             rate: 1.95
//                                         },
//                                         {
//                                             title: translate.instant('MMC.ODD_PRIZE_DB'),
//                                             codePlay: "LEDB",
//                                             methodid: 219,
//                                             rate: 1.95
//                                         },
//                                         {
//                                             title: translate.instant('MMC.ODD_PRIZE_8_OR_DB'),
//                                             codePlay: "LE8ORDB",
//                                             methodid: 221,
//                                             rate: 1.3
//                                         },
//                                         {
//                                             title: translate.instant('MMC.ODD_PRIZE_8_AND_DB'),
//                                             codePlay: "LE8DB",
//                                             methodid: 222,
//                                             rate: 3.7
//                                         },
//                                     ]
//                                 }
//                             ],
//                             noBigIndex: 5,
//                             layoutfastslect: [
//                                 {
//                                     start: '00',
//                                     end: '99'
//                                 }
//                             ]
//                         },
//                         show_str: "X,X,X,X,X",
//                         methoddesc: translate.instant('MMC.DRAGON_TIGER_DESC'),
//                         methodhelp: translate.instant('MMC.DRAGON_TIGER_HELP.DRAGON'),
//                         guideTxt: translate.instant('GUIDE_TXT'),
//                         methodexample: translate.instant('MMC.EXAMPLE'),
//                         exampleInfo: "",
//                         modes: [{
//                             modeid: 1,
//                             name: translate.instant('VND'),
//                             rate: 1
//                         }]
//                     },
//                     {
//                         name: translate.instant('RONG_HO'),
//                         methodid: 224,
//                         selectType: "deTopBot",
//                         selectArea: {
//                             mname: "de-hr",
//                             LayoutTopBot: [
//                                 {
//                                     title: translate.instant('RONG_HO'),
//                                     no: [
//                                         {
//                                             title: translate.instant('RONG'),
//                                             codePlay: "RONG",
//                                             methodid: 224,
//                                             rate: 1.95
//                                         },
//                                         {
//                                             title: translate.instant('HO'),
//                                             codePlay: "Ho",
//                                             methodid: 225,
//                                             rate: 1.95
//                                         },
//                                         {
//                                             title: translate.instant('HOA'),
//                                             codePlay: "RHHOA",
//                                             methodid: 226,
//                                             rate: 90
//                                         },
//                                     ]
//                                 }
//                             ],
//                             noBigIndex: 5,
//                             layoutfastslect: [
//                                 {
//                                     start: '00',
//                                     end: '99'
//                                 }
//                             ]
//                         },
//                         show_str: "X,X,X,X,X",
//                         methoddesc: translate.instant('MMC.DRAGON_TIGER_DESC'),
//                         methodhelp: translate.instant('MMC.DRAGON_TIGER_HELP.DRAGON'),
//                         guideTxt: translate.instant('GUIDE_TXT'),
//                         methodexample: translate.instant('MMC.EXAMPLE'),
//                         exampleInfo: "",
//                         modes: [{
//                             modeid: 1,
//                             name: translate.instant('VND'),
//                             rate: 1
//                         }]
//                     },
//                     {
//                         name: translate.instant('BO_DOI_DONG_NHAT'),
//                         methodid: 227,
//                         selectType: "deTopBot",
//                         selectArea: {
//                             mname: "de-hr",
//                             LayoutTopBot: [
//                                 {
//                                     title: translate.instant('BO_DOI_DONG_NHAT'),
//                                     no: [
//                                         {
//                                             title: translate.instant('MMC.DOUBLE_PRIZE_8'),
//                                             codePlay: "SD8",
//                                             methodid: 227,
//                                             rate: 8.5
//                                         },
//                                         {
//                                             title: translate.instant('MMC.DOUBLE_PRIZE_8_OR_DB'),
//                                             codePlay: "SD8DB",
//                                             methodid: 228,
//                                             rate: 5
//                                         },
//                                         {
//                                             title: translate.instant('MMC.DOUBLE_PRIZE_DB'),
//                                             codePlay: "SDDB",
//                                             methodid: 229,
//                                             rate: 8.5
//                                         },
//                                         {
//                                             title: translate.instant('MMC.DOUBLE_18_PRIZES'),
//                                             codePlay: "SD18",
//                                             methodid: 230,
//                                             rate: 1.12
//                                         },
//                                     ]
//                                 }
//                             ],
//                             noBigIndex: 5,
//                             layoutfastslect: [
//                                 {
//                                     start: '00',
//                                     end: '99'
//                                 }
//                             ]
//                         },
//                         show_str: "X,X,X,X,X",
//                         methoddesc: translate.instant('MMC.DOUBLE_NUMBER_DESC'),
//                         methodhelp: translate.instant('MMC.DOUBLE_NUMBER_HELP.DOUBLE_PRIZE_8'),
//                         guideTxt: translate.instant('GUIDE_TXT'),
//                         methodexample: translate.instant('MMC.EXAMPLE'),
//                         exampleInfo: "",
//                         modes: [{
//                             modeid: 1,
//                             name: translate.instant('VND'),
//                             rate: 1
//                         }]
//                     },
//                     {
//                         name: translate.instant('TAM_CO_TU_QUY'),
//                         methodid: 231,
//                         selectType: "deTopBot",
//                         selectArea: {
//                             mname: "de-tctq",
//                             LayoutTopBot: [
//                                 {
//                                     title: translate.instant('TAM_CO_TU_QUY'),
//                                     no: [
//                                         {
//                                             title: translate.instant('TAM_CO'),
//                                             codePlay: "TAMCO",
//                                             methodid: 231,
//                                             rate: 5.5
//                                         },
//                                         {
//                                             title: translate.instant('TU_QUY'),
//                                             codePlay: "TUQUY",
//                                             methodid: 232,
//                                             rate: 60
//                                         },
//                                     ]
//                                 }
//                             ],
//                             noBigIndex: 5,
//                             layoutfastslect: [
//                                 {
//                                     start: '00',
//                                     end: '99'
//                                 }
//                             ]
//                         },
//                         show_str: "X,X,X,X,X",
//                         methoddesc: translate.instant('MMC.THREE_OF_A_KIND_DESC'),
//                         methodhelp: translate.instant('MMC.THREE_OF_A_KIND_HELP'),
//                         guideTxt: translate.instant('GUIDE_TXT'),
//                         methodexample: translate.instant('MMC.THREE_OF_A_KIND_EXAMPLE'),
//                         exampleInfo: "",
//                         modes: [{
//                             modeid: 1,
//                             name: translate.instant('VND'),
//                             rate: 1
//                         }]
//                     },
//                     {
//                         name: translate.instant('DONG_TAY_NAM_BAC'),
//                         methodid: 233,
//                         selectType: "deTopBot",
//                         selectArea: {
//                             mname: "de-tctq",
//                             LayoutTopBot: [
//                                 {
//                                     title: translate.instant('DONG'),
//                                     no: [
//                                         {
//                                             title: translate.instant('MMC.EAST_PRIZE_8'),
//                                             codePlay: "DONG8",
//                                             methodid: 233,
//                                             rate: 3.63
//                                         },
//                                         {
//                                             title: translate.instant('MMC.EAST_PRIZE_DB'),
//                                             codePlay: "DONGDB",
//                                             methodid: 237,
//                                             rate: 3.63
//                                         },
//                                     ]
//                                 },
//                                 {
//                                     title: translate.instant('TAY'),
//                                     no: [
//                                         {
//                                             title: translate.instant('MMC.WEST_PRIZE_8'),
//                                             codePlay: "TAY8",
//                                             methodid: 234,
//                                             rate: 3.63
//                                         },
//                                         {
//                                             title: translate.instant('MMC.WEST_PRIZE_DB'),
//                                             codePlay: "TAYDB",
//                                             methodid: 238,
//                                             rate: 3.63
//                                         },
//                                     ]
//                                 },
//                                 {
//                                     title: translate.instant('NAM'),
//                                     no: [
//                                         {
//                                             title: translate.instant('MMC.NORTH_PRIZE_8'),
//                                             codePlay: "NAM8",
//                                             methodid: 235,
//                                             rate: 3.63
//                                         },
//                                         {
//                                             title: translate.instant('MMC.NORTH_PRIZE_DB'),
//                                             codePlay: "NAMDB",
//                                             methodid: 239,
//                                             rate: 3.63
//                                         },
//                                     ]
//                                 },
//                                 {
//                                     title: translate.instant('BAC'),
//                                     no: [
//                                         {
//                                             title: translate.instant('MMC.SOUTH_PRIZE_8'),
//                                             codePlay: "BAC8",
//                                             methodid: 236,
//                                             rate: 3.63
//                                         },
//                                         {
//                                             title: translate.instant('MMC.SOUTH_PRIZE_DB'),
//                                             codePlay: "BACDB",
//                                             methodid: 240,
//                                             rate: 3.63
//                                         },
//                                     ]
//                                 }
//                             ],
//                             noBigIndex: 5,
//                             layoutfastslect: [
//                                 {
//                                     start: '00',
//                                     end: '99'
//                                 }
//                             ]
//                         },
//                         show_str: "X,X,X,X,X",
//                         methoddesc: translate.instant('MMC.EAST_WEST_NORTH_SOUTH_DESC'),
//                         methodhelp: translate.instant('MMC.EAST_WEST_NORTH_SOUTH_DESC'),
//                         guideTxt: translate.instant('GUIDE_TXT'),
//                         methodexample: translate.instant('MMC.EXAMPLE'),
//                         exampleInfo: "",
//                         modes: [{
//                             modeid: 1,
//                             name: translate.instant('VND'),
//                             rate: 1
//                         }]
//                     },
//                     {
//                         name: translate.instant('KIM_MOC_THUY_HOA_THO'),
//                         methodid: 241,
//                         selectType: "deTopBot",
//                         selectArea: {
//                             mname: "de-kmtht",
//                             LayoutTopBot: [
//                                 {
//                                     title: translate.instant('KIM'),
//                                     no: [
//                                         {
//                                             title: translate.instant('MMC.METAL_PRIZE_8'),
//                                             codePlay: "KIM8",
//                                             methodid: 241,
//                                             rate: 4.6
//                                         },
//                                         {
//                                             title: translate.instant('MMC.METAL_PRIZE_DB'),
//                                             codePlay: "KIMDB",
//                                             methodid: 246,
//                                             rate: 4.6
//                                         },
//                                     ]
//                                 },
//                                 {
//                                     title: translate.instant('MOC'),
//                                     no: [
//                                         {
//                                             title: translate.instant('MMC.WOOD_PRIZE_8'),
//                                             codePlay: "MOC8",
//                                             methodid: 242,
//                                             rate: 4.6
//                                         },
//                                         {
//                                             title: translate.instant('MMC.WOOD_PRIZE_DB'),
//                                             codePlay: "MOCDB",
//                                             methodid: 247,
//                                             rate: 4.6
//                                         },
//                                     ]
//                                 },
//                                 {
//                                     title: translate.instant('THUY'),
//                                     no: [
//                                         {
//                                             title: translate.instant('MMC.WATER_PRIZE_8'),
//                                             codePlay: "THUY8",
//                                             methodid: 201,
//                                             rate: 4.6
//                                         },
//                                         {
//                                             title: translate.instant('MMC.WATER_DB'),
//                                             codePlay: "THUYDB",
//                                             methodid: 248,
//                                             rate: 4.6
//                                         },
//                                     ]
//                                 },
//                                 {
//                                     title: translate.instant('HOA'),
//                                     no: [
//                                         {
//                                             title: translate.instant('MMC.FIRE_PRIZE_8'),
//                                             codePlay: "HOA8",
//                                             methodid: 201,
//                                             rate: 4.6
//                                         },
//                                         {
//                                             title: translate.instant('MMC.FIRE_DB'),
//                                             codePlay: "HOADB",
//                                             methodid: 249,
//                                             rate: 4.6
//                                         },
//                                     ]
//                                 },
//                                 {
//                                     title: translate.instant('THO'),
//                                     no: [
//                                         {
//                                             title: translate.instant('MMC.EARTH_PRIZE_8'),
//                                             codePlay: "THO8",
//                                             methodid: 201,
//                                             rate: 4.6
//                                         },
//                                         {
//                                             title: translate.instant('MMC.EARTH_DB'),
//                                             codePlay: "THODB",
//                                             methodid: 250,
//                                             rate: 4.6
//                                         },
//                                     ]
//                                 }
//                             ],
//                             noBigIndex: 5,
//                             layoutfastslect: [
//                                 {
//                                     start: '00',
//                                     end: '99'
//                                 }
//                             ]
//                         },
//                         show_str: "X,X,X,X,X",
//                         methoddesc: translate.instant('MMC.METAL_WOOD_WATER_FIRE_EARTH_DESC'),
//                         methodhelp: translate.instant('MMC.METAL_WOOD_WATER_FIRE_EARTH_DESC'),
//                         guideTxt: translate.instant('GUIDE_TXT'),
//                         methodexample: translate.instant('MMC.EXAMPLE'),
//                         exampleInfo: "",
//                         modes: [{
//                             modeid: 1,
//                             name: translate.instant('VND'),
//                             rate: 1
//                         }]
//                     },
//                 ]
//             },
//         ]
//     }
// ];

import { TranslateService } from "ng2-translate";
import {LotteryGame} from "./LotteryGame";

/**
 * Created by Owner on 2016/8/4.
 */

export const mbdbFace = (translate: TranslateService): LotteryGame[] => [
    {
        isdefault: true,
        title: translate.instant('DANH_DE'),
        status: 0,
        label: [
            {
                gtitle: translate.instant('MIEN_BAC'),
                label: [
                    {
                        name: translate.instant('DE_DAC_BIET'),
                        methodid: 1000,
                        selectType: "zxfs",
                        selectArea: {
                            mname: "dedacbiet",
                            layout: [
                                {
                                    title: translate.instant('CHUC'),
                                    no: "0|1|2|3|4|5|6|7|8|9"
                                },
                                {
                                    title: translate.instant('DON_VI'),
                                    no: "0|1|2|3|4|5|6|7|8|9"
                                }
                            ],
                            noBigIndex: 5,
                            layoutfastslect: [
                                {
                                    start: '00',
                                    end: '99'
                                }
                            ]
                        },
                        show_str: "X,X,X,X,X",
                        methoddesc: translate.instant('DE_DAC_BIET_DESC'),
                        methodhelp: translate.instant('DE_DAC_BIET_HELP'),
                        guideTxt: translate.instant('GUIDE_TXT'),
                        methodexample: translate.instant('DE_DAC_BIET_EXAMPLE'),
                        exampleInfo: "",
                        modes: [{
                            modeid: 1,
                            name: translate.instant('VND'),
                            rate: 1
                        }]
                    },
                   // TAIXUI
                   {
                    name: translate.instant('TAI_XIU'),
                    methodid: 200,
                    selectType: "deTopBot",
                    selectArea: {
                        mname: "detx",
                        LayoutTopBot: [
                            {
                                title: translate.instant('TAI'),
                                no: [
                                    {
                                        title: translate.instant('TAI_GIAI_8'),
                                        codePlay: "TAI8",
                                        methodid: 200,
                                        rate: 1.95
                                    },
                                    {
                                        title: translate.instant('TAI_GIAI_DB'),
                                        codePlay: "TAIDB",
                                        methodid: 201,
                                        rate: 1.95
                                    },
                                    {
                                        title: translate.instant('TAI_GIAI_8_OR_DB'),
                                        codePlay: "TAI8DB",
                                        methodid: 204,
                                        rate: 1.3
                                    },
                                    {
                                        title: translate.instant('TAI_GIAI_8_AND_DB'),
                                        codePlay: "TAI8VDB",
                                        methodid: 205,
                                        rate: 3.7
                                    },
                                    {
                                        title: translate.instant('TAI_AND_CHAN_GIAI_8'),
                                        codePlay: "TAICHAN8",
                                        methodid: 206,
                                        rate: 3.63
                                    },
                                    {
                                        title: translate.instant('TAI_AND_LE_GIAI_8'),
                                        codePlay: "TAILE8",
                                        methodid: 207,
                                        rate: 3.63
                                    },
                                    {
                                        title: translate.instant('TAI_AND_CHAN_GIAI_DB'),
                                        codePlay: "TAICHANDB",
                                        methodid: 208,
                                        rate: 3.63
                                    },
                                    {
                                        title: translate.instant('TAI_AND_LE_GIAI_DB'),
                                        codePlay: "TAILEDB",
                                        methodid: 209,
                                        rate: 3.63
                                    }
                                ]
                            },
                            {
                                title: translate.instant('XIU'),
                                no: [
                                    {
                                        title: translate.instant('XIU_GIAI_DB'),
                                        codePlay: "XIUDB",
                                        methodid: 202,
                                        rate: 1.95
                                    },
                                    {
                                        title: translate.instant('XIU_GIAI_8'),
                                        codePlay: "XIU8",
                                        methodid: 203,
                                        rate: 1.95
                                    },
                                    {
                                        title: translate.instant('XIU_GIAI_8_OR_DB'),
                                        codePlay: "XIU8DB",
                                        methodid: 210,
                                        rate: 1.3
                                    },
                                    {
                                        title: translate.instant('XIU_GIAI_8_AND_DB'),
                                        codePlay: "XIU8VDB",
                                        methodid: 211,
                                        rate: 3.7
                                    },
                                    {
                                        title: translate.instant('XIU_AND_CHAN_GIAI_8'),
                                        codePlay: "XIUCHAN8",
                                        methodid: 212,
                                        rate: 3.63
                                    },
                                    {
                                        title: translate.instant('XIU_AND_LE_GIAI_8'),
                                        codePlay: "XIULE8",
                                        methodid: 213,
                                        rate: 3.63
                                    },
                                    {
                                        title: translate.instant('XIU_AND_CHAN_GIAI_DB'),
                                        codePlay: "XIUCHANDB",
                                        methodid: 214,
                                        rate: 3.63
                                    },
                                    {
                                        title: translate.instant('XIU_AND_LE_GIAI_DB'),
                                        codePlay: "XIULEDB",
                                        methodid: 215,
                                        rate: 3.63
                                    }
                                ]
                            }
                        ],
                        noBigIndex: 5,
                        layoutfastslect: [
                            {
                                start: '00',
                                end: '99'
                            }
                        ]
                    },
                    show_str: "X,X,X,X,X",
                    methoddesc: translate.instant('METHOD_DESC_TAI_XIU'),
                    methodhelp: translate.instant('METHOD_HELP_TAI_XIU'),
                    guideTxt: translate.instant('GUIDE_TEXT_COMMON'),
                    methodexample: translate.instant('METHOD_EXAMPLE_COMMON'),
                    exampleInfo: "",
                    modes: [{
                        modeid: 1,
                        name: "VND",
                        rate: 1
                    }]
                },
                {
                    name: translate.instant('MMC.EVEN_ODD'),
                    methodid: 216,
                    selectType: "deTopBot",
                    selectArea: {
                        mname: "de-cl",
                        LayoutTopBot: [
                            {
                                title: translate.instant('MMC.EVEN'),
                                no: [
                                    {
                                        title: translate.instant('MMC.EVEN_PRIZE_8'),
                                        codePlay: "CHAN8",
                                        methodid: 216,
                                        rate: 1.95
                                    },
                                    {
                                        title: translate.instant('MMC.EVEN_PRIZE_DB'),
                                        codePlay: "CHANDB",
                                        methodid: 218,
                                        rate: 1.95
                                    },
                                    {
                                        title: translate.instant('MMC.EVEN_PRIZE_8_OR_DB'),
                                        codePlay: "CHAN8ORDB",
                                        methodid: 220,
                                        rate: 1.3
                                    },
                                    {
                                        title: translate.instant('MMC.EVEN_PRIZE_8_AND_DB'),
                                        codePlay: "CHAN8VDB",
                                        methodid: 223,
                                        rate: 3.7
                                    },
                                ]
                            },
                            {
                                title: translate.instant('MMC.ODD'),
                                no: [{
                                    title: translate.instant('MMC.ODD_PRIZE_8'),
                                    codePlay: "LE8",
                                    methodid: 217,
                                    rate: 1.95
                                },
                                {
                                    title: translate.instant('MMC.ODD_PRIZE_DB'),
                                    codePlay: "LEDB",
                                    methodid: 219,
                                    rate: 1.95
                                },
                                {
                                    title: translate.instant('MMC.ODD_PRIZE_8_OR_DB'),
                                    codePlay: "LE8ORDB",
                                    methodid: 221,
                                    rate: 1.3
                                },
                                {
                                    title: translate.instant('MMC.ODD_PRIZE_8_AND_DB'),
                                    codePlay: "LE8DB",
                                    methodid: 222,
                                    rate: 3.7
                                },
                                ]
                            }
                        ],
                        noBigIndex: 5,
                        layoutfastslect: [
                            {
                                start: '00',
                                end: '99'
                            }
                        ]
                    },
                    show_str: "X,X,X,X,X",
                    methoddesc: translate.instant('MMC.EVEN_ODD_DESC'),
                    methodhelp: `
                        <b>${translate.instant('MMC.EVEN_ODD_HELP.EVEN_PRIZE_8')}</b><br>
                        <b>${translate.instant('MMC.EVEN_ODD_HELP.ODD_PRIZE_8')}</b><br>
                        <b>${translate.instant('MMC.EVEN_ODD_HELP.EVEN_PRIZE_DB')}</b><br>
                        <b>${translate.instant('MMC.EVEN_ODD_HELP.ODD_PRIZE_DB')}</b><br>
                        <b>${translate.instant('MMC.EVEN_ODD_HELP.EVEN_PRIZE_8_OR_DB')}</b><br>
                        <b>${translate.instant('MMC.EVEN_ODD_HELP.ODD_PRIZE_8_OR_DB')}</b><br>
                        <b>${translate.instant('MMC.EVEN_ODD_HELP.ODD_PRIZE_8_AND_DB')}</b><br>
                        <b>${translate.instant('MMC.EVEN_ODD_HELP.EVEN_PRIZE_8_AND_DB')}</b><br>`,
                    guideTxt: translate.instant('MMC.GUIDE_TXT'),
                    methodexample: translate.instant('MMC.EXAMPLE'),
                    exampleInfo: "",
                    modes: [{
                        modeid: 1,
                        name: "VND",
                        rate: 1
                    }]
                },

                {
                    name: translate.instant('MMC.DRAGON_TIGER.TITLE'),
                    methodid: 224,
                    selectType: "deTopBot",
                    selectArea: {
                        mname: "de-hr",
                        LayoutTopBot: [
                            {
                                title: translate.instant('MMC.DRAGON_TIGER.TITLE'),
                                no: [
                                    {
                                        title: translate.instant('MMC.DRAGON_TIGER.DRAGON'),
                                        codePlay: "RONG",
                                        methodid: 224,
                                        rate: 1.95
                                    },
                                    {
                                        title: translate.instant('MMC.DRAGON_TIGER.TIGER'),
                                        codePlay: "Ho",
                                        methodid: 225,
                                        rate: 1.95
                                    },
                                    {
                                        title: translate.instant('MMC.DRAGON_TIGER.DRAW'),
                                        codePlay: "RHHOA",
                                        methodid: 226,
                                        rate: 90
                                    }
                                ]
                            }
                        ],
                        noBigIndex: 5,
                        layoutfastslect: [
                            {
                                start: '00',
                                end: '99'
                            }
                        ]
                    },
                    show_str: "X,X,X,X,X",
                    methoddesc: translate.instant('MMC.DRAGON_TIGER.METHOD_DESC'),
                    methodhelp: translate.instant('MMC.DRAGON_TIGER.METHOD_HELP'),
                    guideTxt: translate.instant('GUIDE_TEXT_COMMON'),
                    methodexample: translate.instant('METHOD_EXAMPLE_COMMON'),
                    exampleInfo: "",
                    modes: [{
                        modeid: 1,
                        name: translate.instant('VND'),
                        rate: 1
                    }]
                },

                {
                    name: translate.instant('SO_DOI'),
                    methodid: 227,
                    selectType: "deTopBot",
                    selectArea: {
                        mname: "de-hr",
                        LayoutTopBot: [
                            {
                                title: translate.instant('SO_DOI'),
                                no: [
                                    {
                                        title: translate.instant('SO_DOI_GIAI_8'),
                                        codePlay: "SD8",
                                        methodid: 227,
                                        rate: 8.5
                                    },
                                    {
                                        title: translate.instant('SO_DOI_GIAI_8_OR_DB'),
                                        codePlay: "SD8DB",
                                        methodid: 228,
                                        rate: 5
                                    },
                                    {
                                        title: translate.instant('SO_DOI_GIAI_DB'),
                                        codePlay: "SDDB",
                                        methodid: 229,
                                        rate: 8.5
                                    },
                                    {
                                        title: translate.instant('SO_DOI_18_GIAI'),
                                        codePlay: "SD18",
                                        methodid: 230,
                                        rate: 1.12
                                    }
                                ]
                            }
                        ],
                        noBigIndex: 5,
                        layoutfastslect: [
                            {
                                start: '00',
                                end: '99'
                            }
                        ]
                    },
                    show_str: "X,X,X,X,X",
                    methoddesc: translate.instant('METHOD_DESC_SO_DOI'),
                    methodhelp: translate.instant('METHOD_HELP_SO_DOI'),
                    guideTxt: translate.instant('GUIDE_TEXT_COMMON'),
                    methodexample: translate.instant('METHOD_EXAMPLE_COMMON'),
                    exampleInfo: "",
                    modes: [{
                        modeid: 1,
                        name: "VND",
                        rate: 1
                    }]
                },
                {
                    name: translate.instant('TAM_CO_TU_QUY'),
                    methodid: 231,
                    selectType: "deTopBot",
                    selectArea: {
                        mname: "de-tctq",
                        LayoutTopBot: [
                            {
                                title: translate.instant('TAM_CO_TU_QUY'),
                                no: [
                                    {
                                        title: translate.instant('TAM_CO'),
                                        codePlay: "TAMCO",
                                        methodid: 231,
                                        rate: 5.5
                                    },
                                    {
                                        title: translate.instant('TU_QUY'),
                                        codePlay: "TUQUY",
                                        methodid: 232,
                                        rate: 60
                                    }
                                ]
                            }
                        ],
                        noBigIndex: 5,
                        layoutfastslect: [
                            {
                                start: '00',
                                end: '99'
                            }
                        ]
                    },
                    show_str: "X,X,X,X,X",
                    methoddesc: translate.instant('METHOD_DESC_TAM_CO_TU_QUY'),
                    methodhelp: translate.instant('METHOD_HELP_TAM_CO_TU_QUY'),
                    guideTxt: translate.instant('GUIDE_TEXT_COMMON'),
                    methodexample: translate.instant('METHOD_EXAMPLE_COMMON'),
                    exampleInfo: "",
                    modes: [{
                        modeid: 1,
                        name: "VND",
                        rate: 1
                    }]
                },
                {
                    name: translate.instant('MMC.EAST_WEST_NORTH_SOUTH'),
                    methodid: 233,
                    selectType: "deTopBot",
                    selectArea: {
                        mname: "de-tctq",
                        LayoutTopBot: [
                            {
                                title: translate.instant('MMC.EAST'),
                                no: [{
                                    title: translate.instant('MMC.EAST_PRIZE_8'),
                                    codePlay: "DONG8",
                                    methodid: 233,
                                    rate: 3.63
                                },
                                {
                                    title: translate.instant('MMC.EAST_PRIZE_DB'),
                                    codePlay: "DONGDB",
                                    methodid: 237,
                                    rate: 3.63
                                },
                                ]
                            },
                            {
                                title: translate.instant('MMC.WEST'),
                                no: [{
                                    title: translate.instant('MMC.WEST_PRIZE_8'),
                                    codePlay: "TAY8",
                                    methodid: 234,
                                    rate: 3.63
                                },
                                {
                                    title: translate.instant('MMC.WEST_PRIZE_DB'),
                                    codePlay: "TAYDB",
                                    methodid: 238,
                                    rate: 3.63
                                },
                                ]
                            },
                            {
                                title: translate.instant('MMC.NORTH'),
                                no: [{
                                    title: translate.instant('MMC.NORTH_PRIZE_8'),
                                    codePlay: "NAM8",
                                    methodid: 235,
                                    rate: 3.63
                                },
                                {
                                    title: translate.instant('MMC.NORTH_PRIZE_DB'),
                                    codePlay: "NAMDB",
                                    methodid: 239,
                                    rate: 3.63
                                },
                                ]
                            },
                            {
                                title: translate.instant('MMC.SOUTH'),
                                no: [{
                                    title: translate.instant('MMC.SOUTH_PRIZE_8'),
                                    codePlay: "BAC8",
                                    methodid: 236,
                                    rate: 3.63
                                },
                                {
                                    title: translate.instant('MMC.SOUTH_PRIZE_DB'),
                                    codePlay: "BACDB",
                                    methodid: 240,
                                    rate: 3.63
                                },
                                ]
                            }

                        ],
                        noBigIndex: 5,
                        layoutfastslect: [
                            {
                                start: '00',
                                end: '99'
                            }
                        ]
                    },
                    show_str: "X,X,X,X,X",
                    methoddesc: translate.instant('MMC.EAST_WEST_NORTH_SOUTH_DESC'),
                    methodhelp: `
                    <b>${translate.instant('MMC.EAST_WEST_NORTH_SOUTH_HELP.EAST_PRIZE_8')}</b><br>
                    <b>${translate.instant('MMC.EAST_WEST_NORTH_SOUTH_HELP.EAST_PRIZE_DB')}</b><br>
                    <b>${translate.instant('MMC.EAST_WEST_NORTH_SOUTH_HELP.WEST_PRIZE_8')}</b><br>
                    <b>${translate.instant('MMC.EAST_WEST_NORTH_SOUTH_HELP.WEST_PRIZE_DB')}</b><br>
                    <b>${translate.instant('MMC.EAST_WEST_NORTH_SOUTH_HELP.NORTH_PRIZE_8')}</b><br>
                    <b>${translate.instant('MMC.EAST_WEST_NORTH_SOUTH_HELP.NORTH_PRIZE_DB')}</b><br>
                    <b>${translate.instant('MMC.EAST_WEST_NORTH_SOUTH_HELP.SOUTH_PRIZE_8')}</b><br>
                    <b>${translate.instant('MMC.EAST_WEST_NORTH_SOUTH_HELP.SOUTH_PRIZE_DB')}</b><br>`,
                    guideTxt: translate.instant('MMC.GUIDE_TXT'),
                    methodexample: translate.instant('MMC.EXAMPLE'),
                    exampleInfo: "",
                    modes: [{
                        modeid: 1,
                        name: "VND",
                        rate: 1
                    }]
                },

                {
                    name: translate.instant('MMC.METAL_WOOD_WATER_FIRE_EARTH'),
                    methodid: 241,
                    selectType: "deTopBot",
                    selectArea: {
                        mname: "de-kmtht",
                        LayoutTopBot: [
                            {
                                title: translate.instant('MMC.METAL'),
                                no: [{
                                    title: translate.instant('MMC.METAL_PRIZE_8'),
                                    codePlay: "KIM8",
                                    methodid: 241,
                                    rate: 4.6
                                },
                                {
                                    title: translate.instant('MMC.METAL_PRIZE_DB'),
                                    codePlay: "KIMDB",
                                    methodid: 246,
                                    rate: 4.6
                                },
                                ]
                            },
                            {
                                title: translate.instant('MMC.WOOD'),
                                no: [{
                                    title: translate.instant('MMC.WOOD_PRIZE_8'),
                                    codePlay: "MOC8",
                                    methodid: 242,
                                    rate: 4.6
                                },
                                {
                                    title: translate.instant('MMC.WOOD_PRIZE_DB'),
                                    codePlay: "MOCDB",
                                    methodid: 247,
                                    rate: 4.6
                                },
                                ]
                            },
                            {
                                title: translate.instant('MMC.WATER'),
                                no: [{
                                    title: translate.instant('MMC.WATER_PRIZE_8'),
                                    codePlay: "THUY8",
                                    methodid: 201,
                                    rate: 4.6
                                },
                                {
                                    title: translate.instant('MMC.WATER_DB'),
                                    codePlay: "THUYDB",
                                    methodid: 248,
                                    rate: 4.6
                                },
                                ]
                            },
                            {
                                title: translate.instant('MMC.FIRE'),
                                no: [{
                                    title: translate.instant('MMC.FIRE_PRIZE_8'),
                                    codePlay: "HOA8",
                                    methodid: 201,
                                    rate: 4.6
                                },
                                {
                                    title: translate.instant('MMC.FIRE_DB'),
                                    codePlay: "HOADB",
                                    methodid: 249,
                                    rate: 4.6
                                },
                                ]
                            },
                            {
                                title: translate.instant('MMC.EARTH'),
                                no: [{
                                    title: translate.instant('MMC.EARTH_PRIZE_8'),
                                    codePlay: "THO8",
                                    methodid: 201,
                                    rate: 4.6
                                },
                                {
                                    title: translate.instant('MMC.EARTH_DB'),
                                    codePlay: "THODB",
                                    methodid: 250,
                                    rate: 4.6
                                },
                                ]
                            }

                        ],
                        noBigIndex: 5,
                        layoutfastslect: [
                            {
                                start: '00',
                                end: '99'
                            }
                        ]
                    },
                    show_str: "X,X,X,X,X",
                    methoddesc: translate.instant('MMC.METAL_WOOD_WATER_FIRE_EARTH_DESC'),
                    methodhelp: `
                    <b>${translate.instant('MMC.METAL_WOOD_WATER_FIRE_EARTH_HELP.METAL_PRIZE_8')}</b><br>
                    <b>${translate.instant('MMC.METAL_WOOD_WATER_FIRE_EARTH_HELP.METAL_PRIZE_DB')}</b><br>
                    <b>${translate.instant('MMC.METAL_WOOD_WATER_FIRE_EARTH_HELP.WOOD_PRIZE_8')}</b><br>
                    <b>${translate.instant('MMC.METAL_WOOD_WATER_FIRE_EARTH_HELP.WOOD_PRIZE_DB')}</b><br>
                    <b>${translate.instant('MMC.METAL_WOOD_WATER_FIRE_EARTH_HELP.WATER_PRIZE_8')}</b><br>
                    <b>${translate.instant('MMC.METAL_WOOD_WATER_FIRE_EARTH_HELP.WATER_DB')}</b><br>
                    <b>${translate.instant('MMC.METAL_WOOD_WATER_FIRE_EARTH_HELP.FIRE_PRIZE_8')}</b><br>
                    <b>${translate.instant('MMC.METAL_WOOD_WATER_FIRE_EARTH_HELP.FIRE_DB')}</b><br>
                    <b>${translate.instant('MMC.METAL_WOOD_WATER_FIRE_EARTH_HELP.EARTH_PRIZE_8')}</b><br>
                    <b>${translate.instant('MMC.METAL_WOOD_WATER_FIRE_EARTH_HELP.EARTH_DB')}</b><br>`,
                    guideTxt: translate.instant('MMC.GUIDE_TXT'),
                    methodexample: translate.instant('MMC.EXAMPLE'),
                    exampleInfo: "",
                    modes: [{
                        modeid: 1,
                        name: "VND",
                        rate: 1
                    }]
                },
                ]
            },
            
        ]
    }
];




// WEBPACK FOOTER //
// ./src/+lotteryFace/mbdb.ts